import { connect } from 'react-redux'
import { compose } from 'recompose'

import { selectors as UserPreferencesSelectors } from 'data/userPreferences'

import {
  makesSubscriptions,
  mergeActionAsMetadata,
  itemInsertions,
  dataFetched as dataFetchedAction,
} from 'data/graphql'

import { setSubscriptionStatus as setSubscriptionStatusAction } from 'data/ui/actions'

import NotificationsAPI from 'remote/notifications'

import { ALL_NOTIFICATIONS_LIST_NAME } from 'data/notifications'
import { NOTIFICATION_JUST_CREATED } from 'data/notifications/actionTypes'

const providesNotificationsSubscriptions = compose(
  connect(
    state => ({
      mutedChannelIds: UserPreferencesSelectors.getMutedChannelIds(state),
    }),
    {
      dispatch: x => x,
      dataFetched: dataFetchedAction,
      setSubscriptionStatus: setSubscriptionStatusAction,
    },
    (
      { mutedChannelIds, ...stateProps },
      { dispatch, ...dispatchProps },
      ownProps
    ) => {
      return {
        notificationsCreated: data => {
          const notifications = data.createdNotifications.reduce(
            (filteredNotifications, { notification }) => {
              const notificationRelatedToMutedChannel =
                notification &&
                notification.metadata &&
                mutedChannelIds.has(notification.metadata.channelId)
              return notificationRelatedToMutedChannel
                ? filteredNotifications
                : [...filteredNotifications, notification]
            },
            []
          )
          const insertions = data.createdNotifications.map(
            ({ newPositionAmongAll }) => newPositionAmongAll
          )

          const notificationCreatedAction = {
            type: NOTIFICATION_JUST_CREATED,
            payload: notifications,
          }
          const dataAction = dataFetchedAction(data)
          const paginationAction = itemInsertions(
            ALL_NOTIFICATIONS_LIST_NAME,
            insertions
          )

          const withData = mergeActionAsMetadata(
            'graphql',
            notificationCreatedAction,
            dataAction
          )
          const withDataAndPagination = mergeActionAsMetadata(
            'pagination',
            withData,
            paginationAction
          )

          return dispatch(withDataAndPagination)
        },
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
      }
    }
  ),

  makesSubscriptions({
    query: NotificationsAPI.notificationsCreated,
    mapPropsToVariables: () => ({}),
    getOnResultFromProps: ({
      dataFetched,
      setSubscriptionStatus,
      notificationsCreated,
    }) => ({ result, meta }) => {
      const {
        createdNotifications,
        usersNotifications,
      } = result.data.notificationsCreated

      dataFetched(
        createdNotifications
          .map(i => i.notification)
          .concat(usersNotifications),
        meta
      )
      notificationsCreated(result.data.notificationsCreated)
      setSubscriptionStatus({ type: 'notificationsCreated', data: result.data })
    },
  }),

  makesSubscriptions({
    query: NotificationsAPI.notificationsUpdated,
    mapPropsToVariables: () => ({}),
    getOnResultFromProps: ({ dataFetched, setSubscriptionStatus }) => ({
      result,
      meta,
    }) => {
      const {
        updatedNotifications,
        usersNotifications,
      } = result.data.notificationsUpdated

      dataFetched(
        updatedNotifications
          .map(i => i.notification)
          .concat(usersNotifications),
        meta
      )

      setSubscriptionStatus({ type: 'notificationsUpdated', data: result.data })
    },
  }),

  makesSubscriptions({
    query: NotificationsAPI.notificationsUnreadCountUpdated,
    mapPropsToVariables: () => ({}),
    getOnResultFromProps: ({ dataFetched }) => ({ result }) => {
      const {
        id,
        unreadNotificationsCount,
      } = result.data.notificationsUnreadCountUpdated

      dataFetched({
        id,
        unreadNotificationsCount,
        __typename: 'UserNotifications',
      })
    },
  })
)

export default providesNotificationsSubscriptions
